import { PaymentHistory } from "@app/models/PaymentHistory";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class PaymentHistoryApi extends HOAApiBase{

    constructor(){
        super('PaymentHistoryApi')
    }

    /**
     * Payment History
     * Retrieve the payment history for a given user\n
     * @param id Unique identifier for a user
     */
    public homeownersIdPaymentHistoriesGet(id: number): Observable<PaymentHistory[]> {
        if (!id) {
            throw new Error('Missing required parameter id when calling homeownersIdPaymentHistoriesGet');
        }

        const localVarPath = this.createUrl(this.getBasePath(), `/homeowners/${id}/paymentHistories`);

        return this.http.get<PaymentHistory[]>(localVarPath);
    }
    /**
     * Payment History
     * Retrieve the payment history for a given payment method\n
     * @param id DB Id of the payment method (card or bank account)
     */
    public paymentMethodsIdPaymentHistoriesGet(id: number): Observable<PaymentHistory[]> {
        if (!id) {
            throw new Error('Missing required parameter id when calling paymentMethodsIdPaymentHistoriesGet');
        }

        const localVarPath = this.createUrl(this.getBasePath(), `/paymentMethods/${id}/paymentHistories`);

        return this.http.get<PaymentHistory[]>(localVarPath);
    }
    /**
     * Payment History
     * Retrieve the payment history for a given property\n
     * @param id DB Id of the property
     */
    public propertiesIdPaymentHistoriesGet(id: number): Observable<PaymentHistory[]> {
        if (!id) {
            throw new Error('Missing required parameter id when calling propertiesIdPaymentHistoriesGet');
        }

        const localVarPath = this.createUrl(this.getBasePath(), `/properties/${id}/paymentHistories`);

        return this.http.get<PaymentHistory[]>(localVarPath);
    }

    /**
     * Guest Payment History
     * Retrieve the payment history for a given property\n
     * @param id DB Id of the property
     */
    public propertiesIdGuestPaymentHistoriesGet(homeownerId: number, propertyId: number): Observable<PaymentHistory[]> {
        if (!homeownerId) {
            throw new Error('Missing required parameter id when calling propertiesIdGuestPaymentHistoriesGet');
        }

        const localVarPath = this.createUrl(this.getLocalPath(), `/guestPayment/homeowners/${homeownerId}/properties/${propertyId}/paymentHistories`);

        return this.http.get<PaymentHistory[]>(localVarPath);
    }
}

